import {Injectable} from "@angular/core";
import {BaseSystemConfigurationValues} from "./base.system.configuration.manager";
import {SystemConfigurationService} from "./system.configuration.service";
import {Observable} from "rxjs";
import {ISystemConfiguration} from "../interfaces/interfaces";
import {map, share} from "rxjs/operators";

/**
 Service class for getting system configuration from server after validity checks.
 */

@Injectable({
  providedIn: 'root'
})
export class PreLoginSystemConfigurationValues extends BaseSystemConfigurationValues {

  public preLoginCachedSysCfgObservable: Observable<ISystemConfiguration>;

  constructor(cfg: SystemConfigurationService) {
    super(cfg);
    this.preLoginCachedSysCfgObservable = cfg.getPreLoginSystemConfiguration().pipe(share());
  }

  public GetCreateAccountEnabledAsync(): Observable<boolean> {
    return this.preLoginCachedSysCfgObservable.pipe(map(sysCfg => {
      return this.getBoolean('PP_CreateAccountEnabled');
    }));
  }

  public get CreateAccountEnabled() {
      return this.getBoolean('PP_CreateAccountEnabled');
  }

  public GetCreateNewPatientOnAccountCreationEnabledAsync(): Observable<boolean> {
    return this.preLoginCachedSysCfgObservable.pipe(map(sysCfg => {
      return this.getBoolean('PP_CreateNewPatientOnAccountCreationEnabled');
    }));
  }

  public get CreateNewPatientOnAccountCreationEnabled() {
    return this.getBoolean('PP_CreateNewPatientOnAccountCreationEnabled');
  }

  public GetUserPasswordPatternAsync(): Observable<number> {
    return this.preLoginCachedSysCfgObservable.pipe(map(sysCfg => {
      return this.getNumber('PP_UserPasswordPattern');
    }));
  }

  public get UserPasswordPattern() {
    return this.getNumber('PP_UserPasswordPattern');
  }

  public GetUserPasswordLengthAsync(): Observable<number> {
    return this.preLoginCachedSysCfgObservable.pipe(map(sysCfg => {
      return this.getNumber('PP_UserPasswordLength');
    }));
  }

  public get UserPasswordLength() {
    return this.getNumber('PP_UserPasswordLength');
  }

  public GetMainContactTelephoneAsync(): Observable<string> {
    return this.preLoginCachedSysCfgObservable.pipe(map(sysCfg => {
      return this.getValidatedString('PP_MainContactTelephone');
    }));
  }

  public get MainContactTelephone() {
    return this.getValidatedString('PP_MainContactTelephone');
  }

  public GetLockExpirationTimeInMinutesAsync(): Observable<number> {
    return this.preLoginCachedSysCfgObservable.pipe(map(sysCfg => {
      return this.getNumber('PP_LockExpirationTimeInMinutes');
    }));
  }

  public get LockExpirationTimeInMinutes() {
    return this.getNumber('PP_LockExpirationTimeInMinutes');
  }
}
